import { Injectable } from "@angular/core";
import { MaintenanceControlDto } from "../../dto/maintenanceControl.dto";
import { ServerConnection } from "../../http/serverConnection";
import { WsDao } from "../../http/wsDao";

@Injectable({
    providedIn: "root",
})
export class MaintenanceControlsWsDao extends WsDao<MaintenanceControlDto> {
    static readonly WS = "maintenance-controls";

    public saveList(serverConnection: ServerConnection, equipmentId: string, inspectionId: string, internalId: string, maintenanceControls: MaintenanceControlDto[]) {
        return new Promise<MaintenanceControlDto[]>((resolve, reject) => {
            let tokens = new Map<string, string>();
            tokens.set("equipmentId", equipmentId);
            tokens.set("inspectionId", inspectionId);

            let body = [];
            maintenanceControls.forEach(maintenanceControl => {
                body.push(maintenanceControl.toBody());
            });

            serverConnection.post(this.constructor.name, MaintenanceControlsWsDao.WS + "/:equipmentId/_bulk?inspectionId=:inspectionId", tokens, body)
                .then(response => {
                    resolve(maintenanceControls);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    }

    public listByEquipment(serverConnection: ServerConnection, equipmentId: string, inspectionId: string): Promise<MaintenanceControlDto[]> {
        return new Promise<MaintenanceControlDto[]>((resolve, reject) => {
            let tokens = new Map<string, string>();
            tokens.set("equipmentId", equipmentId);
            tokens.set("inspectionId", inspectionId);

            serverConnection.get(this.constructor.name, MaintenanceControlsWsDao.WS + "/:equipmentId?_limit=NOLIMIT&inspectionId=:inspectionId", tokens)
                .then(response => {
                    let result: MaintenanceControlDto[] = [];
                    if (response.body instanceof Array) {
                        (response.body as Array<any>).forEach(value => {
                            let maintenanceControlDto = MaintenanceControlDto.fromBody(value, equipmentId);
                            result.push(maintenanceControlDto);
                        });
                    }

                    result = result.sort((a, b) => {
                        return a.order - b.order;
                    });
                    resolve(result);
                })
                .catch(reason => {
                    reject(reason);
                });
        });
    }

    public getById(serverConnection: ServerConnection, id: string): Promise<MaintenanceControlDto> {
        throw new Error("Not implemented");
    }

    public save(serverConnection: ServerConnection, entity: MaintenanceControlDto): Promise<MaintenanceControlDto> {
        throw new Error("Method not implemented.");
    }
}
